import { render, staticRenderFns } from "./EModalEstenderEtapaProfessor.vue?vue&type=template&id=9faee174&scoped=true"
import script from "./EModalEstenderEtapaProfessor.vue?vue&type=script&lang=js"
export * from "./EModalEstenderEtapaProfessor.vue?vue&type=script&lang=js"
import style0 from "./EModalEstenderEtapaProfessor.vue?vue&type=style&index=0&id=9faee174&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9faee174",
  null
  
)

export default component.exports